import type {AddressWidgetConfig, SlotWidgetConfig} from '../widgets/types'
import {WidgetType} from '../widgets/types'

export function toHeaderWidget(widget: AddressWidgetConfig): SlotWidgetConfig {
  return {
    widget_id: `${widget.widget_id}.header`,
    type: WidgetType.SLOT,
    slot: {
      lead: widget.selected_lead,
      body1: {
        align: 'leading',
        title: {
          items: widget.selected_description.items.map(item => ({
            ...item,
            font_size: 20,
            font_weight: 'medium',
            color: 'textMain',
          })),
        },
      },
    },
  }
}
